import { useState, useContext } from 'react';
import { motion } from "framer-motion";
import Loader from '../NavBar/Loader/Loader';
import { loadingContext, loginContext } from '../../Context';
import './LoginRegister.css';

const LoginRegister = () => {
    const [isLogin, setIsLogin] = useState(true);
    const [firstName, setFirstname] = useState('');
    const [lastName, setLastname] = useState('');
    const [email, setEmail] = useState('');
    const [isSucessFul, setIsSucessFul] = useState(false);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [responseMessage, setResponseMessage] = useState('');

    const loadingCtx = useContext(loadingContext);
    const { login } = useContext(loginContext);
    
    const isLoading = loadingCtx.state.isLoading;

    const NODE_SERVER_BASE_URL = 'https://eai.lmc.gatech.edu/app';

    const resetMsg = () => {
        setResponseMessage('');
        setIsSucessFul(false);
    }

    const handleLogin = async (event) => {
        event.preventDefault();
        loadingCtx.dispatch({ type: "on" });
        resetMsg();
        
        const loginPayload = { username, password };
        
        try {
            const response = await fetch(`${NODE_SERVER_BASE_URL}/api/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(loginPayload)
            });

            console.log(`${NODE_SERVER_BASE_URL}/api/login`);

            const data = await response.json();
            setIsSucessFul(response.ok);
            setResponseMessage(data.message);

            if(response.ok){
                // Call login from context to set cookies and context state

                await login({ username, password }).then(() => {
                    setTimeout(() => window.location.href = '/intro', 1000);
                });

            } else {
                console.error('Login failed:', data);
            }

            console.log('Login data', data);
            console.log('Login response.ok', response.ok);

        } catch (error) {
            setResponseMessage('An unexpected error occurred, please try again.');
            console.error('Error during login:', error);
        }

        loadingCtx.dispatch({ type: "off" });
    };

    const handleRegister = async (event) => {
        event.preventDefault();
        loadingCtx.dispatch({ type: "on" });
        resetMsg();

        try {
            const response = await fetch(`${NODE_SERVER_BASE_URL}/api/register`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ firstName, lastName, username, email, password })
            });

            const data = await response.json();
            setIsSucessFul(response.ok);
            setResponseMessage(data.message);

        } catch (error) {
            setResponseMessage('An unexpected error occurred, please try again.');
            console.error('Error during registration:', error);
        }

        loadingCtx.dispatch({ type: "off" });
    };

    return (
        <div className="content">
            <div className="tabcontent">
                <div className="container">
                    <div className="login-register-container">
                        <div className="tabs">
                            <button onClick={() => setIsLogin(true)}><span className={isLogin ? 'text active' : 'text'}>Login</span></button>
                            <button onClick={() => setIsLogin(false)}><span className={!isLogin ? 'text active' : 'text'}>Register</span></button>
                            <div className="indicator" style={{ transform: isLogin ? 'translateX(0%)' : 'translateX(100%)' }}></div>
                        </div>

                        <div className="form-container">
                            <div className={`form-wrapper ${isLogin ? 'login-active' : 'register-active'}`}>
                                <form onSubmit={handleRegister} className="register-form">
                                    <h2 className="text">Register</h2>
                                    <div className="input-group">
                                        <span className="text">First Name</span>
                                        <input
                                            type="text"
                                            value={firstName}
                                            onChange={(e) => setFirstname(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="input-group">
                                        <span className="text">Last Name</span>
                                        <input
                                            type="text"
                                            value={lastName}
                                            onChange={(e) => setLastname(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="input-group">
                                        <span className="text">Username</span>
                                        <input
                                            type="text"
                                            value={username}
                                            onChange={(e) => setUsername(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="input-group">
                                        <span className="text">Email</span>
                                        <input
                                            type="email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="input-group">
                                        <span className="text">Password</span>
                                        <input
                                            type="password"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <motion.button 
                                        type="submit"
                                        className="button"
                                        title="Register Now!"
                                        whileHover={{ scale: 1.05 }}
                                        whileTap={{ scale: 0.8 }}
                                        id="register-btn"
                                    >
                                        <span className="text">Register</span>
                                    </motion.button>
                                </form>

                                <form onSubmit={handleLogin} className="login-form">
                                    <h2 className="text">Login</h2>
                                    <div className="input-group">
                                        <span className="text">Username</span>
                                        <input
                                            type="text"
                                            value={username}
                                            onChange={(e) => setUsername(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="input-group">
                                        <span className="text">Password</span>
                                        <input
                                            type="password"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <motion.button 
                                        type="submit"
                                        className="button"
                                        title="Let us login!"
                                        whileHover={{ scale: 1.05 }}
                                        whileTap={{ scale: 0.8 }}
                                        id="login-btn"
                                    >
                                        <span className="text">Login</span>
                                    </motion.button>
                                </form>
                            </div>
                            {isLoading ? <Loader /> : <p className={isSucessFul ? 'success' : 'failure'}>{responseMessage}</p>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginRegister;
